import type { Asset, Entry } from 'contentful';
import type { LOCALE_CODE } from '~~/lib/ContentfulService';
import { supportsLocales } from '~/utils/guards/supportsLocales';
import { isAsset } from '~/utils/guards/isAsset';

/**
 * Checks if the given entry is enabled in the given locale.
 * If the given entry does not support `locales`, `true` is returned.
 */
export function isEntryEnabledInLocale(
  entryOrAsset: Entry<unknown> | Asset,
  locale?: LOCALE_CODE
): boolean {
  if (!locale) {
    return false;
  }
  if (isAsset(entryOrAsset) || !supportsLocales(entryOrAsset)) {
    return true;
  }
  // the locales can be undefined if the field was added to an existing content
  // type. If the locales are empty, it should be display in every language.
  // @see https://gcp.baslerweb.com/jira/browse/WEB2-2411
  if (
    !entryOrAsset.fields.locales ||
    entryOrAsset.fields.locales.length === 0
  ) {
    return true;
  }

  return entryOrAsset.fields.locales.includes(locale);
}
